export default __webpack_public_path__ + "static/media/Lora-MediumItalic.ee225d08.ttf";